import * as React from 'react';
import { useState, useEffect, forwardRef } from 'react';

/** Material UI Packages. */
import { Box, Button, Slide, Dialog, AppBar, Toolbar, IconButton, Typography } from '@mui/material';

/** Material UI Icons. */
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

/** Redux Packages. */
import { useDispatch } from 'react-redux';

/** Redux Reducers. */
import { setSnackbar } from '../../state/slices/snackBarSlice';

/** Internal Components. */
import { customized_style } from '../../theme/Styles';
import { callAPI } from '../../api/useApiRequest';
import RefTable from './RefTable';

/**  Showing dialog effect  */
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function RefDialog(props) {
    /** Get props from Account.js. */
    const { accounts, setAccounts, reference, setDeleted, email, getAccessTokenSilently } = props;
    /** Get props from AccountTable.js. */
    const { refDialogOpen, setRefDialogOpen, selectedId } = props;

    const dispatch = useDispatch();

    /** State for a selected refId based on rows. */
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    /** Sharing data for datagrid row. */
    const [refRow, setRefRow] = useState([]);

    /** Effect to sort references when the reference list changes. */
    useEffect(() => {
        const sorted_ref = [...reference].sort((a, b) => a.name.localeCompare(b.name));
        setRefRow(sorted_ref);
    }, [reference]);

    /** Handle to update temp data to actual data & open Snackbar. */
    const handleSaveBtn = () => {
        const ref_info = [...accounts]
            .filter((item) => item.id === selectedId)
            .map((obj) => {
                const selectedItems = [...reference].filter((item) => rowSelectionModel.includes(item.id));
                obj.filteration = [...selectedItems];
                return obj;
            });

        callAPI({
            method: 'post',
            module: 'accounts',
            component: 'sharing',
            getAccessTokenSilently,
            email: email,
            obj: JSON.stringify(ref_info),
            onSuccess: (resp) => {
                const remainder = [...accounts].filter((item) => item.id !== selectedId);
                const new_accounts = [...remainder, ...ref_info];
                setAccounts(new_accounts);
                setDeleted(resp.data.body.deleted);
                dispatch(
                    setSnackbar({
                        open: true,
                        message: 'References have been successfully saved.',
                        severity: 'success',
                    }),
                );
            },
            onError: () => {
                dispatch(
                    setSnackbar({
                        open: true,
                        message: 'Something went wrong. Please try again.',
                        severity: 'error',
                    }),
                );
            },
        });

        /** POST request to DB */
        // apiRequest('accounts', 'sharing', email, ref_info)
        //     .then((response) => {
        //         if (response.data['body-json'].statusCode === 200) {
        //             const remainder = [...accounts].filter((item) => item.id !== selectedId);
        //             const new_accounts = [...remainder, ...ref_info];
        //             setAccounts(new_accounts);
        //             setDeleted(response.data['body-json'].body.deleted);
        //             setSnackbar({
        //                 open: true,
        //                 message: response.data['body-json'].body.message,
        //                 severity: 'success',
        //             });
        //         } else {
        //             setSnackbar({
        //                 open: true,
        //                 message: response.data['body-json'].body.message,
        //                 severity: 'error',
        //             });
        //         }
        //     })
        //     .catch((error) => {
        //         setSnackbar({
        //             open: true,
        //             message: 'Something went wrong. Please try again.',
        //             severity: 'error',
        //         });
        //     });
    };

    /** Handle to update temp data to actual data & open Snackbar & close dialog */
    const handleSaveCloseBtn = () => {
        handleSaveBtn();
        setRefDialogOpen(false);
    };

    /** Handle to remind save and close a dialog for references. */
    const handleRefDialogClose = () => {
        setRefDialogOpen(false);
    };

    return (
        <>
            <Dialog maxWidth="lg" open={refDialogOpen} onClose={handleRefDialogClose} TransitionComponent={Transition}>
                <Box sx={{ height: 500 }}>
                    <AppBar sx={{ bgcolor: '#00647e', position: 'relative' }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleRefDialogClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h6">
                                References
                            </Typography>
                            <Button color="inherit" sx={customized_style.itemButtons_save} onClick={handleSaveBtn}>
                                <SaveIcon />
                                SAVE
                            </Button>
                            <Button color="inherit" sx={customized_style.itemButtons_save} onClick={handleSaveCloseBtn}>
                                <SaveIcon />
                                SAVE & CLOSE
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ my: 2, mx: 5 }}>
                        <RefTable
                            refRow={refRow}
                            rowSelectionModel={rowSelectionModel}
                            setRowSelectionModel={setRowSelectionModel}
                            accounts={accounts}
                            selectedId={selectedId}
                        />
                    </Box>
                </Box>
            </Dialog>
        </>
    );
}
